import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { RoleEnum } from '@/api/rest/resources/types/membership';
import { Goal, GoalPaths, GoalPathsMap } from '@/api/rest/resources/types/organization';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useUser } from '@/lib/auth';

import { FormCardFieldMultipleChoice } from './form/FormCardField';
import { FORM_FIELD_NAMES } from './form/OnboardingForm';
import { SectionHeader } from './Section';

export const OnboardingGoals = () => {
  const { t } = useTranslation();

  const user = useUser();
  const isAdmin = user.membership.role === RoleEnum.admin;
  const isStaff = useIsStaffUser();

  return (
    <Stack spacing={12}>
      <SectionHeader i18nPath='shared.onboarding.goals.description' />
      <Stack spacing={8}>
        {Object.keys(Goal).map((goal) => (
          <Stack className='gap-4' key={`goal-section-${goal}`}>
            <span className='typography-body1 text-text-secondary font-bold'>
              {t(`shared.onboarding.goals.goals.${goal as keyof typeof Goal}.title`)}
            </span>
            {GoalPathsMap[goal as keyof typeof Goal].map((goalPath) => (
              <FormCardFieldMultipleChoice
                key={`goal-${goalPath}`}
                title={t(
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  `shared.onboarding.goals.goals.${goal as keyof typeof Goal}.goals.${goalPath as keyof typeof GoalPaths}.title` as any,
                )}
                description={t(
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  `shared.onboarding.goals.goals.${goal as keyof typeof Goal}.goals.${goalPath as keyof typeof GoalPaths}.description` as any,
                )}
                formField={FORM_FIELD_NAMES.GOALS}
                formValue={goalPath}
                isMultipleChoice={true}
                disabled={!isAdmin && !isStaff}
              />
            ))}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
